<template>
  <div id="app" ref="appRef">
    <div class="loading" v-if="state.loading">
      <img class="loaderLogo" style="max-height:50px;" src="./assets/logo-light.png">
      <div class="la-ball-running-dots">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <!-- Has User -->
    <template v-if="state.authUser === true">
      <template v-if="state.view === 'userView'">
        <sidemenu></sidemenu>

        <template v-if="!state.cmsView">
          <!-- User View Top Bar -->
          <div class="w3-bar w3-top box-shadow" :class="state.width > 1024 ? 'w3-white':'dark'" :style="{'z-index': 4, 'padding-left': navbarPadding}" ref="topbar">
            <div class="w3-bar-item w3-hide-large w3-hover-none" @click="store.toggleMenu()" v-if="state.authUser === true">
              <i class="fas fa-bars"></i>
            </div>
            <div class="w3-bar-item roboto w3-border-right" ref="newButton" :class="showNewMenu ? 'dark' : ''" :style="state.width > 1024 ? 'margin-left:-5px':''" @click="showNewMenu = !showNewMenu">
              <i class="fas fa-plus" :style="{'color': showNewMenu ? '#fff':'#666', 'margin-right':'6px', 'font-size':'12px'}"></i><span style="font-size:13px;">New</span>
            </div>
            <div class="w3-bar-item w3-right" @click="showProfileMenu = !showProfileMenu">
              <i class="fas fa-user"></i>
            </div>
            <div class="w3-bar-item w3-right" @click="showCart()">
              <div class="w3-display-container" style="padding:0 6px;">
                <div v-if="state.cart.items.length > 0" class="w3-display-topright w3-green w3-round-xxlarge" style="line-height:1; font-size:12px; padding:2px 4px 1px; font-family:Roboto;">{{state.cart.items.length}}</div>
                <i class="fas fa-shopping-cart"></i>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- CMS View Top Bar -->
          <div class="w3-bar w3-top box-shadow" :class="state.width > 1024 ? 'w3-white':'dark'" :style="{'z-index': 4, 'padding-left': navbarPadding}" ref="topbar">
            <div class="w3-bar-item w3-hide-large w3-hover-none" @click="store.toggleMenu()" v-if="state.authUser === true">
              <i class="fas fa-bars"></i>
            </div>
            <div class="w3-bar-item roboto" ref="newButton" :style="state.width > 1024 ? 'margin-left:-5px; border-right:1px solid #e0e0e0;':'border-left:1px solid #455a64; border-right:1px solid #455a64;'" @click="showNewCMSMenu = !showNewCMSMenu">
              <i class="fas fa-plus" style="margin-right: 6px; font-size: 12px;"></i><span style="font-size: 13px">New</span>
            </div>
            <a class="w3-bar-item headerSiteLink" :href="'//' + state.activeSite.domain" target="_blank">
              {{state.activeSite.domain}}
            </a>
            <div class="w3-bar-item w3-right" @click="showProfileMenu = !showProfileMenu">
              <i class="fas fa-user"></i>
            </div>
          </div>
        </template>
        <div class="w3-main mainContainer">
          <!-- Top container -->
          <template v-if="showProfileMenu">
            <div class="dropdown w3-bar-block outline w3-white" style="position:fixed; right:0;" @click="showProfileMenu = !showProfileMenu">
              <a v-if="state.user.user_group === 'super'" href="#" @click.prevent="state.fakeClient = !state.fakeClient" class="w3-bar-item w3-border-bottom w3-right-align"><span v-if="state.fakeClient">Admin Mode</span><span v-else>Client Mode</span></a>
              <!-- <a href="#" class="w3-bar-item w3-border-bottom w3-right-align">Alerts</a> -->
              <a href="#" class="w3-bar-item w3-border-bottom w3-right-align" @click.prevent="state.modals.profile = true">Profile</a>
              <a href="#" @click.prevent="store.signOut()" class="w3-bar-item w3-right-align">Logout</a>
            </div>
          </template>
          <template v-if="showNewMenu">
            <div class="dropdown w3-bar-block outline w3-white" :style="{'position':'fixed','left': state.width < 1025 ? ($refs.newButton.offsetLeft + 'px') : '14.5rem','min-width':'200px'}" @click="showNewMenu = !showNewMenu">
              <router-link tag="a" to="/sites" class="w3-bar-item w3-border-bottom">Website</router-link>
              <router-link tag="a" to="/domains" class="w3-bar-item w3-border-bottom">Domain</router-link>
              <router-link tag="a" to="/hosting" class="w3-bar-item w3-border-bottom">Hosting</router-link>
              <router-link tag="a" to="/email" class="w3-bar-item">Email</router-link>
            </div>
          </template>
          <template v-if="showNewCMSMenu">
            <div class="dropdown w3-bar-block outline w3-white newMenu" :style="{'position':'fixed','left': state.width < 1025 ? ($refs.newButton.offsetLeft + 'px') : '14.5rem','min-width':'200px'}" @click="showNewCMSMenu = !showNewCMSMenu">
              <template v-if="state.siteData.content.services.enabled"><router-link tag="a" to="/cms/services-detail" class="w3-bar-item">Service</router-link></template>
              <template v-if="state.siteData.content.products.enabled"><router-link tag="a" to="/cms/products-detail" class="w3-bar-item">Product</router-link></template>
              <template v-if="state.siteData.content.news.enabled"><router-link tag="a" to="/cms/news-detail" class="w3-bar-item">News</router-link></template>
              <template v-if="state.siteData.content.testimonials.enabled"><router-link tag="a" to="/cms/testimonials-detail" class="w3-bar-item">Testimonial</router-link></template>
              <template v-if="state.siteData.content.partners.enabled"><router-link tag="a" to="/cms/partners-detail" class="w3-bar-item">Partner</router-link></template>
              <template v-if="state.siteData.content.faqs.enabled"><router-link tag="a" to="/cms/faqs-detail" class="w3-bar-item">FAQ</router-link></template>
              <template v-if="state.siteData.content.events.enabled"><router-link tag="a" to="/cms/events-detail" class="w3-bar-item">Event</router-link></template>
              <template v-if="state.siteData.content.photos.enabled"><router-link tag="a" to="/cms/photos-detail" class="w3-bar-item">Photo</router-link></template>
              <template v-if="state.siteData.content.videos.enabled"><router-link tag="a" to="/cms/videos-detail" class="w3-bar-item">Video</router-link></template>
              <template v-if="state.siteData.content.audio.enabled"><router-link tag="a" to="/cms/audio-detail" class="w3-bar-item">Audio</router-link></template>
            </div>
          </template>

          <!-- Progress Bar -->
          <vue-ins-progress-bar></vue-ins-progress-bar>
          <!-- Router View -->
          <router-view style="flex:1" />

          <!-- Footer -->
          <template v-if="state.authUser === true && this.$route.name !== undefined && this.$route.name !== 'NotFound'">
            <!-- Footer Top -->
            <!-- <template v-if="!this.state.cmsView">
              <div class="w3-container w3-padding-32 w3-hide-print w3-margin-top" style="background:#272727; color:#fafafa;" :class="{'darkFooter' : state.darkMode}">
                <div class="w3-row">
                  <div class="w3-container w3-third">
                    <h5 class="w3-bottombar w3-border-green w3-padding-bottom">Domains</h5>
                    <p>Register domain</p>
                    <p>Transfer In</p>
                    <p>Transfer Out</p>
                  </div>

                  <div class="w3-container w3-third">
                    <h5 class="w3-bottombar w3-border-red w3-padding-bottom">Email</h5>
                    <p>Manage Accounts</p>
                    <p>Add Mailbox</p>
                    <p>Client Settings</p>
                  </div>

                  <div class="w3-container w3-third">
                    <h5 class="w3-bottombar w3-border-orange w3-padding-bottom">Hosting</h5>
                    <p>Login to cPanel</p>
                    <p>Renew hosting</p>
                    <p>SSL Status</p>
                  </div>
                </div>
              </div>
            </template> -->
            <!-- Footer Bottom -->
            <footer class="w3-container w3-padding-16 w3-bar w3-hide-print" v-if="!state.modals.wizard">
              <span class="w3-bar-item" :class="state.width > 1024 ? '':'bar-center'" style="margin-top:10px;">Copyright &copy; {{ new Date().getFullYear() }} Level Seven Studio</span>
              <span class="w3-bar-item" :class="state.width > 1024 ? 'w3-right':'bar-center'" style="padding:0 16px 3px;">
                <img src="./assets/logo-dark.png" style="max-height:50px;">
              </span>
            </footer>
          </template>
        </div>
      </template>

      <!-- TODO: Verify Email -->
      <template v-if="state.view === 'verifyEmailView'">
        <verify-email></verify-email>
      </template>

    </template><!-- end has user -->
    <template v-else><!-- no user -->
      <div class="w3-light-grey" style="position:absolute; top:0; left:0; min-height:100%; width:100%;">
        <div class="loginLogoContainer">
          <img src="./assets/logo-dark.png" alt="Logo" class="w3-margin-top" style="width:300px;">
        </div>
        <!-- Login -->
        <template v-if="state.view === 'loginView'">
          <div class="outline loginBox w3-white">
            <div class="w3-padding dark headerGrid">
              <header>
                <h5 style="margin:0; line-height:34.4px;">Client Login</h5>
              </header>
              <div>
                <button class="w3-button w3-blue w3-right" style="padding:6px 16px;" @click="state.view = 'register'">Register</button>
              </div>
            </div>
            <div class="w3-container">
              <form class="w3-margin-top w3-margin-bottom" @submit.prevent="signIn()">
                <label>
                  <b>Email</b>
                </label>
                <input class="w3-input w3-border w3-hover-border-black w3-margin-bottom" type="email" v-model="registerData.email" placeholder="Email">
                <label>
                  <b>Password</b>
                </label>
                <input class="w3-input w3-border w3-hover-border-black" type="password" v-model="registerData.password" placeholder="Enter Password">
                <button class="w3-btn w3-btn-block w3-green w3-margin-top">Login</button>
                <!-- TODO: Remember me and forgot password -->
                <!-- <input class="w3-check" type="checkbox" checked="checked"> Remember me -->
                <!-- <span class="w3-right w3-padding w3-margin-top centerSmall"><a href="#">Forgot password?</a></span> -->
                <div v-if="error">
                  {{error.message}}
                </div>
              </form>
            </div>
          </div>
        </template>

        <!-- Register -->
        <template v-if="state.view === 'register'">
          <register></register>
        </template>
      </div>
    </template>

    <!-- Modal User Profile -->
    <template>
      <div class="w3-modal" style="display:block;" v-if="state.modals.profile">
        <div class="w3-modal-content outline">
          <header class="light outline">
            <span class="w3-button w3-display-topright w3-red modalClose" @click="state.modals.profile = false"><i class="fas fa-times" style="margin:0;"></i></span>
            <h5>User Profile</h5>
          </header>
          <div class="w3-row">
            <div class="w3-col s3">
              <img :src="state.user.gravatar" style="width:100%;" />
            </div>
            <div class="w3-col s9">
              <div class="w3-padding-8" style="margin-top:10px;">
                <div>Email: {{state.user.email}}</div>
                <div>Name: {{state.user.displayName}}</div>
                <div>Business: {{state.user.businessName}}</div>
                <div>Phone: {{state.user.phone}}</div>
                <div>Street: {{state.user.address.address1}}</div>
                <div>City: {{state.user.address.city}}</div>
                <div>State: {{state.user.address.state}}</div>
                <div>Zip: {{state.user.address.zip}}</div>
                <!-- update gravatar email? or just use client email... -->
                <!-- <input class="w3-input w3-border w3-hover-border-black" type="email" v-model="state.user.gravatarEmail" placeholder="myemail@somewhere.com">
                <div class="w3-right-align">
                  <button class="w3-button w3-green w3-margin-top" @click="updateImage()">Submit</button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Modal Icons -->
    <template>
      <div class="w3-modal" style="display:block;" v-if="state.modals.iconModal">
        <div class="w3-modal-content outline">
          <header class="light outline">
            <span class="w3-button w3-display-topright w3-red modalClose" @click="state.modals.iconModal = false"><i class="fas fa-times" style="margin:0;"></i></span>
            <h5>Choose Icon</h5>
          </header>
          <div class="w3-padding-8">
            <input class="w3-input w3-border" placeholder="Search..." @keyup="filterIcons($event)" />
          </div>
          <div class="iconModalGrid">
            <div v-for="(icon, index) in icons" :key="index" style="display:flex; flex-direction:column; justify-content:center; align-items:center; height:64px; width:64px; margin:0 auto; font-size:2rem;" @click="chooseIcon(icon)">
              <div :title="icon"><i :class="'fa fa-' + icon"></i></div>
              <div style="font-size:.65rem; color:#424242; text-align:center; max-width:64px;" class="truncate" :title="icon">{{icon}}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Modal Cart Item Added -->
    <template>
      <div class="w3-modal" style="display:block;" v-if="state.modals.cartAdded">
        <div class="w3-modal-content outline">
          <header class="light outline">
            <span class="w3-button w3-display-topright w3-red modalClose" @click="state.modals.cartAdded = false"><i class="fas fa-times" style="margin:0;"></i></span>
            <h5>Added to Cart</h5>
          </header>
          <div class="w3-padding-8">
            <div>
              Item added to cart
            </div>
            <div class="w3-right-align">
              <button class="w3-button w3-dark-blue-grey" @click="$router.push('/cart'); state.modals.cartAdded = false;">View Cart</button>
              <button class="w3-button w3-red" @click="state.modals.cartAdded = false">Close Window</button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Modal Wizard -->
    <template v-if="state.modals.wizard">
      <div class="wizardContainer" ref="wizardContainerRef">
        <site-wizard v-on:changeBGColor="changeBGColor"></site-wizard>
      </div>
    </template>
    <!-- Modal FilePicker -->
    <template>
      <div class="w3-modal" style="display:block;" v-if="state.modals.filePicker">
        <div class="w3-modal-content outline">
          <header class="light outline">
            <span class="w3-button w3-display-topright w3-red modalClose" @click="state.modals.filePicker = false"><i class="fas fa-times" style="margin:0;"></i></span>
            <h5>Choose File</h5>
          </header>
          <!-- <div class="w3-padding-8">
            <input class="w3-input w3-border" placeholder="Search..." @keyup="filterIcons($event)" />
          </div> -->
          <div class="fileModalGrid" style="padding:10px; max-height: 400px; overflow: hidden; overflow-y: scroll;">
            <div v-for="(file, index) in state.filesList" :key="index" @click="selectFile(file, index)" style="border-radius: 5px; border: 1px solid #ccc; padding:4px; text-align:center; overflow:hidden;" :style="activeFile === index ? 'background:rgba(22,38,54,0.1);' : ''">
              <div style="display:flex; flex-direction:column; justify-content:center; align-items:center; height:128px; width:128px; margin:0 auto; font-size:2rem;">
                <template v-if="file.substr(-3).toLowerCase() === 'pdf'">
                  <div class="docCardImg w3-center">
                    <i class="fa fa-file-pdf" style="font-size: 44px;"></i><br/>
                    <span>PDF</span>
                  </div>
                </template>
                <template v-else>
                  <img :src="'https://levelsevenstudio.com/api/images/' + state.activeSite.domain + '/' + file" style="width:100%;" />
                </template>
              </div>
              <span style="font-size:11px; color:#333; word-break: break-all;">{{file}}</span>
            </div>
          </div>
          <footer class="light outline w3-right-align w3-padding-8">
            <button class="w3-button w3-round w3-blue w3-small" @click="chooseFile()">Choose</button>
          </footer>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import sidemenu from '@/components/sidemenu'
import register from '@/components/register'
import verifyEmail from '@/components/verifyEmail'
import siteWizard from '@/components/cms/cmsSiteWizard'

var e5 = require('./md5')
var dataStore = require('./dataStore').default

export default {
  name: 'App',
  data() {
    return {
      state: dataStore.state,
      store: dataStore,
      registerData: {
        email: '',
        password: ''
      },
      loading: false,
      error: dataStore.state.error,
      topbarHeight: 0,
      showProfileMenu: false,
      showNewMenu: false,
      showNewCMSMenu: false,
      navbarPadding: '0',
      activeFile: 0,
      iconsMasterList: ['ad', 'address-book', 'address-card', 'adjust', 'air-freshener', 'align-center', 'align-justify', 'align-left', 'align-right', 'allergies', 'ambulance', 'american-sign-language-interpreting', 'anchor', 'angle-double-down', 'angle-double-left', 'angle-double-right', 'angle-double-up', 'angle-down', 'angle-left', 'angle-right', 'angle-up', 'angry', 'ankh', 'apple-alt', 'archive', 'archway', 'arrow-alt-circle-down', 'arrow-alt-circle-left', 'arrow-alt-circle-right', 'arrow-alt-circle-up', 'arrow-circle-down', 'arrow-circle-left', 'arrow-circle-right', 'arrow-circle-up', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'arrows-alt', 'arrows-alt-h', 'arrows-alt-v', 'assistive-listening-systems', 'asterisk', 'at', 'atlas', 'atom', 'audio-description', 'award', 'backspace', 'backward', 'bacon', 'balance-scale', 'balance-scale-left', 'balance-scale-right', 'ban', 'band-aid', 'barcode', 'bars', 'baseball-ball', 'basketball-ball', 'bath', 'battery-empty', 'battery-full', 'battery-half', 'battery-quarter', 'battery-three-quarters', 'bed', 'beer', 'bell', 'bell-slash', 'bezier-curve', 'bible', 'bicycle', 'biking', 'binoculars', 'biohazard', 'birthday-cake', 'blender', 'blender-phone', 'blind', 'blog', 'bold', 'bolt', 'bomb', 'bone', 'bong', 'book', 'book-dead', 'book-medical', 'book-open', 'book-reader', 'bookmark', 'border-all', 'border-none', 'border-style', 'bowling-ball', 'box', 'box-open', 'boxes', 'braille', 'brain', 'bread-slice', 'briefcase', 'briefcase-medical', 'broadcast-tower', 'broom', 'brush', 'bug', 'building', 'bullhorn', 'bullseye', 'burn', 'bus', 'bus-alt', 'business-time', 'calculator', 'calendar', 'calendar-alt', 'calendar-check', 'calendar-day', 'calendar-minus', 'calendar-plus', 'calendar-times', 'calendar-week', 'camera', 'camera-retro', 'campground', 'candy-cane', 'cannabis', 'capsules', 'car', 'car-alt', 'car-battery', 'car-crash', 'car-side', 'caret-down', 'caret-left', 'caret-right', 'caret-square-down', 'caret-square-left', 'caret-square-right', 'caret-square-up', 'caret-up', 'carrot', 'cart-arrow-down', 'cart-plus', 'cash-register', 'cat', 'certificate', 'chair', 'chalkboard', 'chalkboard-teacher', 'charging-station', 'chart-area', 'chart-bar', 'chart-line', 'chart-pie', 'check', 'check-circle', 'check-double', 'check-square', 'cheese', 'chess', 'chess-bishop', 'chess-board', 'chess-king', 'chess-knight', 'chess-pawn', 'chess-queen', 'chess-rook', 'chevron-circle-down', 'chevron-circle-left', 'chevron-circle-right', 'chevron-circle-up', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'child', 'church', 'circle', 'circle-notch', 'city', 'clinic-medical', 'clipboard', 'clipboard-check', 'clipboard-list', 'clock', 'clone', 'closed-captioning', 'cloud', 'cloud-download-alt', 'cloud-meatball', 'cloud-moon', 'cloud-moon-rain', 'cloud-rain', 'cloud-showers-heavy', 'cloud-sun', 'cloud-sun-rain', 'cloud-upload-alt', 'cocktail', 'code', 'code-branch', 'coffee', 'cog', 'cogs', 'coins', 'columns', 'comment', 'comment-alt', 'comment-dollar', 'comment-dots', 'comment-medical', 'comment-slash', 'comments', 'comments-dollar', 'compact-disc', 'compass', 'compress', 'compress-arrows-alt', 'concierge-bell', 'cookie', 'cookie-bite', 'copy', 'copyright', 'couch', 'credit-card', 'crop', 'crop-alt', 'cross', 'crosshairs', 'crow', 'crown', 'crutch', 'cube', 'cubes', 'cut', 'database', 'deaf', 'democrat', 'desktop', 'dharmachakra', 'diagnoses', 'dice', 'dice-d20', 'dice-d6', 'dice-five', 'dice-four', 'dice-one', 'dice-six', 'dice-three', 'dice-two', 'digital-tachograph', 'directions', 'divide', 'dizzy', 'dna', 'dog', 'dollar-sign', 'dolly', 'dolly-flatbed', 'donate', 'door-closed', 'door-open', 'dot-circle', 'dove', 'download', 'drafting-compass', 'dragon', 'draw-polygon', 'drum', 'drum-steelpan', 'drumstick-bite', 'dumbbell', 'dumpster', 'dumpster-fire', 'dungeon', 'edit', 'egg', 'eject', 'ellipsis-h', 'ellipsis-v', 'envelope', 'envelope-open', 'envelope-open-text', 'envelope-square', 'equals', 'eraser', 'ethernet', 'euro-sign', 'exchange-alt', 'exclamation', 'exclamation-circle', 'exclamation-triangle', 'expand', 'expand-arrows-alt', 'external-link-alt', 'external-link-square-alt', 'eye', 'eye-dropper', 'eye-slash', 'fan', 'fast-backward', 'fast-forward', 'fax', 'feather', 'feather-alt', 'female', 'fighter-jet', 'file', 'file-alt', 'file-archive', 'file-audio', 'file-code', 'file-contract', 'file-csv', 'file-download', 'file-excel', 'file-export', 'file-image', 'file-import', 'file-invoice', 'file-invoice-dollar', 'file-medical', 'file-medical-alt', 'file-pdf', 'file-powerpoint', 'file-prescription', 'file-signature', 'file-upload', 'file-video', 'file-word', 'fill', 'fill-drip', 'film', 'filter', 'fingerprint', 'fire', 'fire-alt', 'fire-extinguisher', 'first-aid', 'fish', 'fist-raised', 'flag', 'flag-checkered', 'flag-usa', 'flask', 'flushed', 'folder', 'folder-minus', 'folder-open', 'folder-plus', 'font', 'football-ball', 'forward', 'frog', 'frown', 'frown-open', 'funnel-dollar', 'futbol', 'gamepad', 'gas-pump', 'gavel', 'gem', 'genderless', 'ghost', 'gift', 'gifts', 'glass-cheers', 'glass-martini', 'glass-martini-alt', 'glass-whiskey', 'glasses', 'globe', 'globe-africa', 'globe-americas', 'globe-asia', 'globe-europe', 'golf-ball', 'gopuram', 'graduation-cap', 'greater-than', 'greater-than-equal', 'grimace', 'grin', 'grin-alt', 'grin-beam', 'grin-beam-sweat', 'grin-hearts', 'grin-squint', 'grin-squint-tears', 'grin-stars', 'grin-tears', 'grin-tongue', 'grin-tongue-squint', 'grin-tongue-wink', 'grin-wink', 'grip-horizontal', 'grip-lines', 'grip-lines-vertical', 'grip-vertical', 'guitar', 'h-square', 'hamburger', 'hammer', 'hamsa', 'hand-holding', 'hand-holding-heart', 'hand-holding-usd', 'hand-lizard', 'hand-middle-finger', 'hand-paper', 'hand-peace', 'hand-point-down', 'hand-point-left', 'hand-point-right', 'hand-point-up', 'hand-pointer', 'hand-rock', 'hand-scissors', 'hand-spock', 'hands', 'hands-helping', 'handshake', 'hanukiah', 'hard-hat', 'hashtag', 'hat-cowboy', 'hat-cowboy-side', 'hat-wizard', 'haykal', 'hdd', 'heading', 'headphones', 'headphones-alt', 'headset', 'heart', 'heart-broken', 'heartbeat', 'helicopter', 'highlighter', 'hiking', 'hippo', 'history', 'hockey-puck', 'holly-berry', 'home', 'horse', 'horse-head', 'hospital', 'hospital-alt', 'hospital-symbol', 'hot-tub', 'hotdog', 'hotel', 'hourglass', 'hourglass-end', 'hourglass-half', 'hourglass-start', 'house-damage', 'hryvnia', 'i-cursor', 'ice-cream', 'icicles', 'icons', 'id-badge', 'id-card', 'id-card-alt', 'igloo', 'image', 'images', 'inbox', 'indent', 'industry', 'infinity', 'info', 'info-circle', 'italic', 'jedi', 'joint', 'journal-whills', 'kaaba', 'key', 'keyboard', 'khanda', 'kiss', 'kiss-beam', 'kiss-wink-heart', 'kiwi-bird', 'landmark', 'language', 'laptop', 'laptop-code', 'laptop-medical', 'laugh', 'laugh-beam', 'laugh-squint', 'laugh-wink', 'layer-group', 'leaf', 'lemon', 'less-than', 'less-than-equal', 'level-down-alt', 'level-up-alt', 'life-ring', 'lightbulb', 'link', 'lira-sign', 'list', 'list-alt', 'list-ol', 'list-ul', 'location-arrow', 'lock', 'lock-open', 'long-arrow-alt-down', 'long-arrow-alt-left', 'long-arrow-alt-right', 'long-arrow-alt-up', 'low-vision', 'luggage-cart', 'magic', 'magnet', 'mail-bulk', 'male', 'map', 'map-marked', 'map-marked-alt', 'map-marker', 'map-marker-alt', 'map-pin', 'map-signs', 'marker', 'mars', 'mars-double', 'mars-stroke', 'mars-stroke-h', 'mars-stroke-v', 'mask', 'medal', 'medkit', 'meh', 'meh-blank', 'meh-rolling-eyes', 'memory', 'menorah', 'mercury', 'meteor', 'microchip', 'microphone', 'microphone-alt', 'microphone-alt-slash', 'microphone-slash', 'microscope', 'minus', 'minus-circle', 'minus-square', 'mitten', 'mobile', 'mobile-alt', 'money-bill', 'money-bill-alt', 'money-bill-wave', 'money-bill-wave-alt', 'money-check', 'money-check-alt', 'monument', 'moon', 'mortar-pestle', 'mosque', 'motorcycle', 'mountain', 'mouse', 'mouse-pointer', 'mug-hot', 'music', 'network-wired', 'neuter', 'newspaper', 'not-equal', 'notes-medical', 'object-group', 'object-ungroup', 'oil-can', 'om', 'otter', 'outdent', 'pager', 'paint-brush', 'paint-roller', 'palette', 'pallet', 'paper-plane', 'paperclip', 'parachute-box', 'paragraph', 'parking', 'passport', 'pastafarianism', 'paste', 'pause', 'pause-circle', 'paw', 'peace', 'pen', 'pen-alt', 'pen-fancy', 'pen-nib', 'pen-square', 'pencil-alt', 'pencil-ruler', 'people-carry', 'pepper-hot', 'percent', 'percentage', 'person-booth', 'phone', 'phone-alt', 'phone-slash', 'phone-square', 'phone-square-alt', 'phone-volume', 'photo-video', 'piggy-bank', 'pills', 'pizza-slice', 'place-of-worship', 'plane', 'plane-arrival', 'plane-departure', 'play', 'play-circle', 'plug', 'plus', 'plus-circle', 'plus-square', 'podcast', 'poll', 'poll-h', 'poo', 'poo-storm', 'poop', 'portrait', 'pound-sign', 'power-off', 'pray', 'praying-hands', 'prescription', 'prescription-bottle', 'prescription-bottle-alt', 'print', 'procedures', 'project-diagram', 'puzzle-piece', 'qrcode', 'question', 'question-circle', 'quidditch', 'quote-left', 'quote-right', 'quran', 'radiation', 'radiation-alt', 'rainbow', 'random', 'receipt', 'record-vinyl', 'recycle', 'redo', 'redo-alt', 'registered', 'remove-format', 'reply', 'reply-all', 'republican', 'restroom', 'retweet', 'ribbon', 'ring', 'road', 'robot', 'rocket', 'route', 'rss', 'rss-square', 'ruble-sign', 'ruler', 'ruler-combined', 'ruler-horizontal', 'ruler-vertical', 'running', 'rupee-sign', 'sad-cry', 'sad-tear', 'satellite', 'satellite-dish', 'save', 'school', 'screwdriver', 'scroll', 'sd-card', 'search', 'search-dollar', 'search-location', 'search-minus', 'search-plus', 'seedling', 'server', 'shapes', 'share', 'share-alt', 'share-alt-square', 'share-square', 'shekel-sign', 'shield-alt', 'ship', 'shipping-fast', 'shoe-prints', 'shopping-bag', 'shopping-basket', 'shopping-cart', 'shower', 'shuttle-van', 'sign', 'sign-in-alt', 'sign-language', 'sign-out-alt', 'signal', 'signature', 'sim-card', 'sitemap', 'skating', 'skiing', 'skiing-nordic', 'skull', 'skull-crossbones', 'slash', 'sleigh', 'sliders-h', 'smile', 'smile-beam', 'smile-wink', 'smog', 'smoking', 'smoking-ban', 'sms', 'snowboarding', 'snowflake', 'snowman', 'snowplow', 'socks', 'solar-panel', 'sort', 'sort-alpha-down', 'sort-alpha-down-alt', 'sort-alpha-up', 'sort-alpha-up-alt', 'sort-amount-down', 'sort-amount-down-alt', 'sort-amount-up', 'sort-amount-up-alt', 'sort-down', 'sort-numeric-down', 'sort-numeric-down-alt', 'sort-numeric-up', 'sort-numeric-up-alt', 'sort-up', 'spa', 'space-shuttle', 'spell-check', 'spider', 'spinner', 'splotch', 'spray-can', 'square', 'square-full', 'square-root-alt', 'stamp', 'star', 'star-and-crescent', 'star-half', 'star-half-alt', 'star-of-david', 'star-of-life', 'step-backward', 'step-forward', 'stethoscope', 'sticky-note', 'stop', 'stop-circle', 'stopwatch', 'store', 'store-alt', 'stream', 'street-view', 'strikethrough', 'stroopwafel', 'subscript', 'subway', 'suitcase', 'suitcase-rolling', 'sun', 'superscript', 'surprise', 'swatchbook', 'swimmer', 'swimming-pool', 'synagogue', 'sync', 'sync-alt', 'syringe', 'table', 'table-tennis', 'tablet', 'tablet-alt', 'tablets', 'tachometer-alt', 'tag', 'tags', 'tape', 'tasks', 'taxi', 'teeth', 'teeth-open', 'temperature-high', 'temperature-low', 'tenge', 'terminal', 'text-height', 'text-width', 'th', 'th-large', 'th-list', 'theater-masks', 'thermometer', 'thermometer-empty', 'thermometer-full', 'thermometer-half', 'thermometer-quarter', 'thermometer-three-quarters', 'thumbs-down', 'thumbs-up', 'thumbtack', 'ticket-alt', 'times', 'times-circle', 'tint', 'tint-slash', 'tired', 'toggle-off', 'toggle-on', 'toilet', 'toilet-paper', 'toolbox', 'tools', 'tooth', 'torah', 'torii-gate', 'tractor', 'trademark', 'traffic-light', 'train', 'tram', 'transgender', 'transgender-alt', 'trash', 'trash-alt', 'trash-restore', 'trash-restore-alt', 'tree', 'trophy', 'truck', 'truck-loading', 'truck-monster', 'truck-moving', 'truck-pickup', 'tshirt', 'tty', 'tv', 'umbrella', 'umbrella-beach', 'underline', 'undo', 'undo-alt', 'universal-access', 'university', 'unlink', 'unlock', 'unlock-alt', 'upload', 'user', 'user-alt', 'user-alt-slash', 'user-astronaut', 'user-check', 'user-circle', 'user-clock', 'user-cog', 'user-edit', 'user-friends', 'user-graduate', 'user-injured', 'user-lock', 'user-md', 'user-minus', 'user-ninja', 'user-nurse', 'user-plus', 'user-secret', 'user-shield', 'user-slash', 'user-tag', 'user-tie', 'user-times', 'users', 'users-cog', 'utensil-spoon', 'utensils', 'vector-square', 'venus', 'venus-double', 'venus-mars', 'vial', 'vials', 'video', 'video-slash', 'vihara', 'voicemail', 'volleyball-ball', 'volume-down', 'volume-mute', 'volume-off', 'volume-up', 'vote-yea', 'vr-cardboard', 'walking', 'wallet', 'warehouse', 'water', 'wave-square', 'weight', 'weight-hanging', 'wheelchair', 'wifi', 'wind', 'window-close', 'window-maximize', 'window-minimize', 'window-restore', 'wine-bottle', 'wine-glass', 'wine-glass-alt', 'won-sign', 'wrench', 'x-ray', 'yen-sign', 'yin-yang'],
      icons: []
    }
  },
  created() {
    this.icons = this.iconsMasterList
    window.addEventListener('beforeunload', this.saveCart)

    if (localStorage.getItem('l7_userauth')) {
      if (localStorage.l7_userauth) {
        this.state.authHeader = JSON.parse(localStorage.l7_userauth)

        dataStore.loginUser().then(response => {
          if (response === 'success') {
            if (this.state.user.status === 'new') {
              this.state.view = 'verifyEmailView'
              this.$router.push('/')
            } else if (this.state.user.status === 'active') {
              this.state.view = 'userView'
              this.$router.push('/')
            } else {
              this.state.view = 'loginView'
            }
          }
        })
      }
    }

    if (localStorage.getItem('l7_cart')) {
      this.state.cart = JSON.parse(localStorage.l7_cart)
    }

    dataStore.getAllProducts().then((res) => {
      this.state.productData = res.data
      for (let plan of this.state.productData.plans.data) {
        if (plan.nickname === 'Domain Registration') {
          this.state.domainPlan = plan
        }
      }
    })
    this.state.error.code = ''
    this.state.error.message = ''
    dataStore.initSiteData()
  },
  mounted() {
    if (this.state.width > 1024) {
      this.navbarPadding = '220px'
    } else {
      this.navbarPadding = '0'
    }
    this.state.view = 'loginView'
  },
  components: {sidemenu, register, verifyEmail, siteWizard},
  methods: {
    updateImage() {
      if (!this.state.user.gravatarEmail) {
        this.state.user.gravatar = require('@/assets/avatar.png')
        this.state.modals.profile = false
      } else {
        const grEmail = this.state.user.gravatarEmail.trim().toLowerCase()
        const hash = e5.md5(grEmail)
        this.state.user.gravatar = 'https://www.gravatar.com/avatar/' + hash
        this.state.modals.profile = false
      }
      dataStore.updateUser()
    },
    showCart() {
      this.$router.push('/cart')
    },
    saveCart() {
      localStorage.setItem('l7_cart', JSON.stringify(this.state.cart))
    },
    signIn() {
      if (this.registerData.email === '') {
        alert('Please enter an email address')
        return
      } else if (this.registerData.password === '') {
        alert('Please enter a password')
        return
      }
      dataStore.makeHeader(this.registerData.email, this.registerData.password).then(result => {
        if (result === 'done') {
          dataStore.loginUser().then(result => {
            if (result === 'success') {
              if (this.state.user.status === 'new') {
                this.state.view = 'verifyEmailView'
                this.$router.push('/')
                this.registerData.password = ''
              } else if (this.state.user.status === 'active') {
                this.state.view = 'userView'
                this.$router.push('/')
                this.registerData.password = ''
              } else {
                // ERROR: status is something other than active or new?
              }
            } else {
              console.log(result)
            }
          })
        }
      })
    },
    chooseIcon(icon) {
      dataStore.setProperty(this.state.selectedIcon, icon)
      this.state.modals.iconModal = false
    },
    selectFile(file, index) {
      this.activeFile = index
    },
    chooseFile() {
      let index = 0;
      for (let item of this.state.siteData.content[this.state.filePickerType].items) {
        if (item.slug === this.state.filePickerSlug) {
          this.state.siteData.content[this.state.filePickerType].items[index][this.state.filePickerPath][this.state.filePickerIndex]['src'] = 'https://levelsevenstudio.com/api/images/' + this.state.activeSite.domain + '/' + this.state.filesList[this.activeFile]
          break
        }
        index++
      }
      this.state.modals.filePicker = false
    },
    filterIcons(event) {
      let value = event.target.value.toLowerCase()
      if (!value || value === '') {
        this.icons = this.iconsMasterList
        return
      }
      this.icons = this.icons.filter(icon => {
        return icon.toLowerCase().includes(value)
      })
    },
    changeBGColor(e) {
      this.$refs.wizardContainerRef.style.backgroundColor = e
    }
  },
  onIdle() {
    // TODO: logout user after some time?
  },
  onActive() {
    dataStore.getClientSites()
  }
}
</script>

<style>
@import "./assets/w3pro.css";
@import "./assets/spinner.css";
@import "./assets/vue2-animate.min.css";
@import "./assets/style.css";
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900|Raleway:300,400,500|Comfortaa|Roboto+Slab');

.wizardContainer {position:fixed; top:0; left:0; bottom:0; right:0; z-index:999; background:#11202f;}
input {font-family:Arial, Helvetica, sans-serif; color:#424242;}
.headerSiteLink {color:#424242; text-decoration:none; overflow:hidden;}
header h2 {font-size:20px;}

@media (max-width:400px) {
  .headerSiteLink {max-width:190px;}
}
@media (max-width:600px) {
  .headerSiteLink {color:#fff;}
  header h2 {font-size:18px;}
}
</style>



// WEBPACK FOOTER //
// src/App.vue